<template>
  <RouterView></RouterView>
</template>

<script>

export default {
  name: 'App',
  components: {},
  methods: {
    dataFromCsv(data){
      this.hafisotData=data;
    }
  },
  data() {
    return {}      
  },
}
 
</script>

<style>
input,
textarea,
button,
text,p,h1{
  font-family: 'Assistant', sans-serif;
}
html, body{
  min-width: 1450px;
}

@font-face {
    font-family:'Assistant', sans-serif;
    src: 'client/public';
}

#app {
  font-family: 'Assistant', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F5F9FF;
}
.nav-bar{
  margin-bottom: 6.3vh;
}

</style>
